


















































































import GrpTagChoice from "@/interfaces/GrpTagChoice";
import { Component, Vue, Prop } from "vue-property-decorator";
import VCheckbox from "../VCheckbox.vue";

@Component({ components: { VCheckbox } })
export default class ChildrenPanel extends Vue {
  @Prop({ default: false }) readonly guestSelected!: boolean;
  @Prop({ default: false }) readonly buyersSelected!: boolean;

  tag = "";

  init(choice: GrpTagChoice | null) {
    this.tag = choice?.tag as string;
  }

  onCheck(tag: string) {
    this.tag = tag;
    this.notify();
  }

  notify() {
    const choice: GrpTagChoice = {
      tag: "",
      type: "scalar",
      isValid: true,
    };
    choice.tag = this.tag;
    this.$emit("choice", choice);
  }
}
